import { render, staticRenderFns } from "./OpzioniSpedizioni.vue?vue&type=template&id=d4b397f0"
import script from "./OpzioniSpedizioni.vue?vue&type=script&lang=ts"
export * from "./OpzioniSpedizioni.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b397f0')) {
      api.createRecord('d4b397f0', component.options)
    } else {
      api.reload('d4b397f0', component.options)
    }
    module.hot.accept("./OpzioniSpedizioni.vue?vue&type=template&id=d4b397f0", function () {
      api.rerender('d4b397f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniSpedizioni.vue"
export default component.exports